import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import DocumentHeadTags from 'components/document-head-tags'
import ReferralInviteSendModal from 'components/modals/referral/send'

const ReferralInviteSend: React.FC = () => {
  const navigate = useNavigate()

  const closeModal = useCallback(() => {
    navigate('/')
  }, [navigate])

  return (
    <div className="Referral_Modal">
      <DocumentHeadTags title="Invite users | DISCO" />
      <ReferralInviteSendModal onClose={closeModal} />
    </div>
  )
}

export default ReferralInviteSend
